export default __webpack_public_path__ + "static/media/1-icon-search-20-px.eb8d31a0.svg";